import {IComponentController} from "angular";


export class UserSubscriptionComponent implements IComponentController {

    public static instance = {
        controller: [UserSubscriptionComponent],
        template: require('./user-subscription.component.html'),
        bindings: {
            icon: '@',
            title: '@',
            status: '='
        }
    };
    private status: boolean;


    constructor() {
        console.log(this.status)
    }
}